var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batch-import-container" },
    [
      _c("div", { staticClass: "batch-row flex" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "batch-row__content" }, [
          _c("div", { staticClass: "batch-row__title" }, [
            _vm._v("填写导入数据信息")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "font12" }, [
            _vm._v(
              "请按照数据模版的格式准备导入数据，模版中的表头名称不可以更改，表头行不能删除"
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("a", { attrs: { href: _vm.href } }, [_vm._v("下载模版")]),
            _c("span", { staticClass: "font12" }, [
              _vm._v(" (" + _vm._s(_vm.date) + "更新)")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "batch-row flex" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "batch-row__content" }, [
          _c("div", { staticClass: "batch-row__title" }, [
            _vm._v("上传填好的信息表")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "font12" }, [
            _vm._v(
              "文件后缀名必须为xls或xlsx（即Excel格式），文件大小不得大于10M，最多支持导入3000条数据"
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "upload-demo",
                  attrs: {
                    accept:
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
                    action: "",
                    multiple: false,
                    limit: 1,
                    "file-list": _vm.fileList,
                    "show-file-list": true,
                    "on-change": _vm.fileChange,
                    "on-exceed": _vm.handleExceed,
                    "auto-upload": false
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "trigger", type: "text", size: "large" },
                      slot: "trigger"
                    },
                    [_vm._v("上传文件")]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-alert",
        {
          attrs: {
            title: "操作提示",
            type: "warning",
            description: "",
            closable: false,
            "show-icon": ""
          }
        },
        [
          _vm._v("\n    1、请点击“下载模版”按钮，将导入模版存于本地；"),
          _c("br"),
          _vm._v("\n    2、根据模版填充信息后，点击“上传文件”选中文件上传；"),
          _c("br"),
          _vm._v(
            "\n    3、新维护的被保人信息，需要在保单保存后再维护理赔信息；\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "batch-row__icon" }, [
      _c("i", { staticClass: "iconfont icon-cloud-download-alt" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "batch-row__icon" }, [
      _c("i", { staticClass: "iconfont icon-cloud-upload-alt" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-afa3dbc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afa3dbc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/batchImport.vue
// module id = null
// module chunks = 